// src/components/Sidebar.js

import React from 'react';
import { NavLink } from 'react-router-dom';
import { Activity } from 'lucide-react';

import {
  HouseDoor,
  Person,
  Heart,
  Droplet,
  GenderFemale,
  GraphUp,
  PersonBadge,
  ShieldCheck,
  FileText,
  BoxArrowRight,
  ClipboardCheck,
  Shield
} from 'react-bootstrap-icons';

import './Sidebar.css';

const user = JSON.parse(localStorage.getItem('user') || '{}');
const podeVerAdmin = user?.cargo === 'ADMIN' || user?.cargo === 'SUPERVISOR';
const temPermissaoLancamento = user?.permissoes?.includes('beta_lancamento');

const Sidebar = ({ user, onLogout }) => {
  const getNavLinkClass = ({ isActive }) =>
    isActive ? 'sidebar-link active' : 'sidebar-link';

  const handleLogoutClick = () => {
    const keysToRemove = [
      'token', 'user', 'currentVisitList', 'visitQueueData',
      'selectedHouseholds', 'selectedHipertensos', 'selectedDiabeticos',
      'selectedGestantes', 'selectedIdosos', 'selectedCriancas', 'selectedMulheres'
    ];
    keysToRemove.forEach(key => localStorage.removeItem(key));
    if (onLogout) onLogout();
  };

  // Inicial do nome para o avatar
  const initials = user
    ? (user.nome || user.login || '?').charAt(0).toUpperCase()
    : '?';

  return (
    <div className="sidebar">

      {/* ─── LOGO ───────────────────────────── */}
      <div className="sidebar-logo">
        <div className="sidebar-logo-icon">
          <Activity size={16} color="white" strokeWidth={2.5} />
        </div>
        <div className="sidebar-logo-text">
          <strong>Saúde Digital</strong>
          <small>ACS · Sistema de Visitas</small>
        </div>
      </div>

      {/* ─── USUÁRIO ────────────────────────── */}
      {user && (
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">{initials}</div>
          <span className="sidebar-user-name">Olá, {user.nome || user.login}</span>
        </div>
      )}

      {/* ─── NAV ────────────────────────────── */}
      <nav className="sidebar-nav">

        <div className="sidebar-heading">Navegação</div>

        <NavLink to="/" className={getNavLinkClass} data-tooltip="Página Inicial" end>
          <span className="link-icon"><HouseDoor size={20} /></span>
          <span className="link-label">Página Inicial</span>
        </NavLink>

        <NavLink to="/pacientes" className={getNavLinkClass} data-tooltip="Pacientes">
          <span className="link-icon"><Person size={20} /></span>
          <span className="link-label">Pacientes</span>
        </NavLink>

        <NavLink to="/folha-visita" className={getNavLinkClass} data-tooltip="Folha de Visita">
          <span className="link-icon"><FileText size={20} /></span>
          <span className="link-label">Folha de Visita</span>
        </NavLink>

    {temPermissaoLancamento && (
        <NavLink to="/lancamento" className={getNavLinkClass} data-tooltip="Lançamento de Visitas">
          <span className="link-icon"><ClipboardCheck size={20} /></span>
          <span className="link-label">Lançamento de Visitas</span>
        </NavLink>
    )}

        <div className="sidebar-heading">Acompanhamentos</div>

        <NavLink to="/hipertensos" className={getNavLinkClass} data-tooltip="Hipertensos">
          <span className="link-icon"><Heart size={20} /></span>
          <span className="link-label">Hipertensos</span>
        </NavLink>

        <NavLink to="/diabeticos" className={getNavLinkClass} data-tooltip="Diabéticos">
          <span className="link-icon"><Droplet size={20} /></span>
          <span className="link-label">Diabéticos</span>
        </NavLink>

        <NavLink to="/gestantes" className={getNavLinkClass} data-tooltip="Gestantes e Puérperas">
          <span className="link-icon"><GenderFemale size={20} /></span>
          <span className="link-label">Gestantes e Puérperas</span>
        </NavLink>

        <NavLink to="/desenvolvimento-infantil" className={getNavLinkClass} data-tooltip="Desenv. Infantil">
          <span className="link-icon"><GraphUp size={20} /></span>
          <span className="link-label">Desenv. Infantil</span>
        </NavLink>

        <NavLink to="/idosos" className={getNavLinkClass} data-tooltip="Idosos">
          <span className="link-icon"><PersonBadge size={20} /></span>
          <span className="link-label">Idosos</span>
        </NavLink>

        <NavLink to="/saude-mulher" className={getNavLinkClass} data-tooltip="Prevenção ao Câncer">
          <span className="link-icon"><ShieldCheck size={20} /></span>
          <span className="link-label">Prevenção ao Câncer</span>
        </NavLink>

        {/* ... (abaixo do botão de sair, ou antes dele) ... */}
        
        {podeVerAdmin && (
            <>
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', margin: '16px 0' }}></div>
                <NavLink to="/admin" className={getNavLinkClass} data-tooltip="Painel de Controle">
                  <span className="link-icon"><Shield size={20} /></span>
                  <span className="link-label">Controle de Acessos</span>
                </NavLink>
            </>
        )}

      </nav>

      {/* ─── LOGOUT ─────────────────────────── */}
      <div className="sidebar-footer">
        <button className="sidebar-logout" onClick={handleLogoutClick}>
          <span className="link-icon"><BoxArrowRight size={20} /></span>
          <span className="link-label">Sair do Sistema</span>
        </button>
      </div>

    </div>
  );
};

export default Sidebar;